import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectedProductSelector } from 'ctm-selectors';

import { ContainerWrapper } from '../products/container_wrapper';

import { ProductCard } from './widget/product_card';
import { ProductContent } from './widget/product_content';
import { BackToResultsButton } from '../comparison/common/back_to_results_button';
import { PriceDisclaimer } from './common/price_disclaimer';
import { coverTypeStateMapping } from '../products/filters/common/filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    twoColumnContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    stickyContainer: {
        height: 'max-content',
        maxWidth: '34.3rem',
        width: '100%',
        position: 'sticky',
        top: 0,
        zIndex: 10
    }
}));

const _PolicyProductTwoColumn = ({ quote, stagedValue, pristineValue }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className="test-policyProduct-two-column">
            <ContainerWrapper padding={['32', '48', '4', '48']}>
                <BackToResultsButton label="Back to all results" variant="tertiary" />
            </ContainerWrapper>
            <ContainerWrapper padding={['16', '48', '0', '48']}>
                <PriceDisclaimer />
            </ContainerWrapper>
            <ContainerWrapper padding={['40', '48', '132', '48']} className={classes.twoColumnContainer}>
                <ContainerWrapper padding={['0', '64', '0', '0']}>
                    <ProductContent quote={quote} stagedValue={stagedValue} pristineValue={pristineValue} />
                    <BackToResultsButton label="Back to all results" variant="secondary" />
                </ContainerWrapper>
                <div className={classes.stickyContainer}>
                    <ProductCard quote={quote} />
                </div>
            </ContainerWrapper>
        </div>
    );
};

_PolicyProductTwoColumn.propTypes = {
    quote: PropTypes.object.isRequired,
    stagedValue: PropTypes.string.isRequired,
    pristineValue: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    const quote = selectedProductSelector(state);
    const { stagedValue, pristineValue } = coverTypeStateMapping(state);
    return {
        quote,
        stagedValue,
        pristineValue
    };
};

const PolicyProductTwoColumn = connect(mapStateToProps)(_PolicyProductTwoColumn);

export { PolicyProductTwoColumn };
